export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10904.e8dca960.jpg";